import { createRouteRef } from '@backstage/core-plugin-api';

/**
 * Root route ref
 * @public
 */
export const rootRouteRef = createRouteRef({
  id: 'endoflife',
});
